import { Box, SxProps, Typography } from "@mui/material";

export const BubbleCount = ({
  color,
  bgColor,
  offset = "100%",
  count,
  sx,
}: {
  color?: string;
  bgColor?: string;
  offset?: string;
  count: number;
  sx?: SxProps;
}) => {
  if (count === 0) return null;
  return (
    <Box
      className="bubble-count"
      sx={{
        top: "50%",
        left: "50%",
        transform: `translate(calc(-50% + ${offset}), calc(-50% - ${offset}))`,
        bgcolor: (theme) => bgColor ?? theme.palette.primary.main,
        color: (theme) => color ?? theme.palette.primary.contrastText,
        position: "absolute",
        bottom: "auto",
        borderRadius: "50px",
        width: "1.1rem",
        height: "1.1rem",
        display: "flex",
        justifyContent: "center",
        ...sx,
      }}
    >
      <Typography variant="caption" className="count" lineHeight={"16px"}>
        {count}
      </Typography>
    </Box>
  );
};
